import React, { useEffect, useState } from "react";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import { BaseUrl } from "../api";
import { IoNotificationsOutline } from "react-icons/io5";

type Deadline = {
  registration_deadline: string;
  remaining_time?: {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
  };
};

const NotificationDrawer = ({
  isOpen,
  toggleDrawer,
  notificationMessage,
  setNotificationMessage,
}: {
  isOpen: boolean;
  toggleDrawer: () => void;
  notificationMessage: string;
  setNotificationMessage: (message: string) => void;
}) => {
  const [deadline, setDeadline] = useState<string | Deadline>("");
  const [notificationCount, setNotificationCount] = useState<number>(0);

  useEffect(() => {
    const getRegistrationDeadline = async () => {
      await fetch(`${BaseUrl}/deadline/`, {
        method: "GET",
      })
        .then((response) => response.json())
        .then((data: string | Deadline) => {
          setDeadline(data);
          if (typeof data !== "string" && data.remaining_time) {
            checkDeadline(data);
          }
        })
        .catch((error) => console.error(error));
    };

    const checkDeadline = (data: Deadline) => {
      if (!data.remaining_time) return;

      const { days, hours, minutes, seconds } = data.remaining_time;

      const totalRemainingTimeInMinutes =
        days * 24 * 60 + hours * 60 + minutes + seconds / 60;

      if (totalRemainingTimeInMinutes <= 5) {
        setNotificationCount((prevState) => prevState + 1);
        setNotificationMessage(
          `Registration deadline is approaching in ${minutes} minutes and ${seconds} seconds`
        );
      }
    };

    getRegistrationDeadline();

    const interval = setInterval(() => {
      if (typeof deadline !== "string" && deadline.remaining_time) {
        checkDeadline(deadline);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (notificationMessage) {
      setNotificationCount((prevState) => prevState + 1);
    }
  }, [notificationMessage]);

  return (
    <>
      <Drawer open={isOpen} onClose={toggleDrawer} direction="right" size={400}>
        <div
          className={`p-4 bg-white dark:bg-gray-800 w-full`}
          aria-labelledby="drawer-navigation-label"
        >
          <div className="flex justify-between items-center">
            <h5 className="text-base font-semibold text-gray-500 uppercase dark:text-gray-400">
              Notifications
            </h5>
            <button
              onClick={toggleDrawer}
              type="button"
              className="bg-[#efefef] p-[9px] rounded-lg"
            >
              <svg
                className="w-3 h-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                />
              </svg>
            </button>
          </div>
          <div className="py-4 overflow-y-auto flex flex-col gap-6">
            {notificationMessage && (
              <div className="flex items-center gap-3 bg-default-300 dark:bg-default-200 hover:bg-default-100 dark:hover:bg-default-300 cursor-pointer px-5 py-[6px] rounded-full">
                <IoNotificationsOutline size={24} />
                <div className="flex flex-col dark:text-white">
                  <span className="text-sm">Notification</span>
                  <span className="text-xs text-gray-500 dark:text-gray-400">
                    {notificationMessage}
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>
      </Drawer>
    </>
  );
};

export default NotificationDrawer;
